import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Criteria } from '../../utils/criteria/criteria';
import { ENVIRONMENT } from '../../../environments/environment';
import { HandleError } from '../../utils/utils';
import { Observable } from 'rxjs';
import { PendingWork } from './pending-work';
import { Session } from '../../session/session';
import { SessionService } from '../../session/session.service';

@Injectable()
export class PendingWorkService {
  constructor(private http: HttpClient, private sessionService: SessionService) { }

  /**
   * @description Obtains the pending work.
   * @param {string} type - module from which the task will be recovered.
   * @return {Observable<PendingWork>} the recovered information.
   */
  public findPendingWork(type: string): Observable<PendingWork> {
    return this.http.get<PendingWork>(ENVIRONMENT.API + '/task/pending/work?type=' + type)
      .pipe(catchError(HandleError.handleErrorObservable));
  }

  /**
   * @description Obtains pending work by criteria.
   * @param {any[]} criteriaFilters - criteria filters array.
   * @return {Observable<PendingWork>} the recovered information.
   */
  public findPendingWorkByCriteria(criteria: Criteria): Observable<PendingWork> {
    let session: Session = this.sessionService.getUserSession();
    criteria.addFilterWhere('equipment.id', session.equipmentId);

    return this.http.get<PendingWork>(ENVIRONMENT.API + '/task/pending/work?criteria=' + criteria.stringify())
      .pipe(catchError(HandleError.handleErrorObservable));
  }

  /**
   * @description Obtains the pending work.
   * @return {Observable<PendingWork>} the recovered information.
   */
  public findAnyPendingWork(): Observable<PendingWork> {
    return this.http.get<PendingWork>(ENVIRONMENT.API + '/task/pending/work')
      .pipe(catchError(HandleError.handleErrorObservable));
  }
}
